import React from 'react'
import InstructorNavbar from '../components/instructor/InstructorNavbar'
import Submissions from '../components/instructor/Submissions'
import Navbar from '../components/Navbar/Navbar'
import ResetPassword from '../components/forgotPassword/ResetPassword'

const SubmissionsPage = () => {
  return (
    <>
    <Navbar/>
    <ResetPassword/>
    </>
  )
}

export default SubmissionsPage